import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
import { getClientId } from '../../utils/config';
export { login };
var loginQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Login(\n    $email: String!\n    $password: String!\n    $client: String!\n    $forceMfa: Boolean\n    $deviceId: String\n  ) {\n    userTokens(\n      params: {\n        email: $email\n        password: $password\n        clientId: $client\n        forceMfa: $forceMfa\n        deviceId: $deviceId\n      }\n    ) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n    }\n  }\n"])));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var errorCodes = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  #this query is only here to enable code generating of ErrorCodes enum\n  query GetErrorCodes {\n    getErrorCodes\n    getMfaErrorPayload {\n      mfa_token\n      uuid\n      email\n    }\n  }\n"])));
function login(_x) {
  return _login.apply(this, arguments);
}
function _login() {
  _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return wrapQuery('login', loginQuery, _objectSpread(_objectSpread({}, params), {}, {
            client: getClientId()
          }));
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.userTokens.tokens);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _login.apply(this, arguments);
}